import type { DealSplitData } from 'models/forms/DealSplitData';
import { AvailableItem, AvailableItems, mergeAvailableItems } from 'models/forms/fields/AvailableItemsField';
import type { FieldValueValidator } from 'models/forms/fields/utils';
import { type FieldFormatter, isHandledBySamePredicate } from 'models/forms/fields/utils';

import type { FieldMetadataBase } from './FieldMetadataBase';

export type SingleCustodianDealSplitFieldData = DealSplitData[] | undefined;

export type SingleCustodianDealSplitFieldMetadata = FieldMetadataBase<
  'SingleCustodianDealSplitField',
  SingleCustodianDealSplitFieldData
> & {
  notionalToSplit: number;
  availableCustodians: AvailableItems;
};

export function isSingleCustodianDealSplitFieldMetadata(val: unknown): val is SingleCustodianDealSplitFieldMetadata {
  return (val as SingleCustodianDealSplitFieldMetadata).type === 'SingleCustodianDealSplitField';
}

export function mergeSingleCustodianDealSplitFieldMetadata(
  firstField: SingleCustodianDealSplitFieldMetadata,
  secondField: SingleCustodianDealSplitFieldMetadata,
): SingleCustodianDealSplitFieldMetadata {
  return {
    ...firstField,
    availableCustodians: mergeAvailableItems(firstField.availableCustodians, secondField.availableCustodians),
  };
}
export const singleCustodianDealSplitFieldMetadataFormatter: FieldFormatter<SingleCustodianDealSplitFieldMetadata> = {
  areSameType: isHandledBySamePredicate(isSingleCustodianDealSplitFieldMetadata),
  merge: mergeSingleCustodianDealSplitFieldMetadata,
  isHandled: isSingleCustodianDealSplitFieldMetadata,
  withDefault: f => ({
    ...f,
    availableCustodians: [{ label: '', value: '', translationKey: undefined }, ...f.availableCustodians],
  }),
};
export const singleCustodianDealSplitFieldMetadataValidator: FieldValueValidator<
  SingleCustodianDealSplitFieldMetadata,
  AvailableItem
> = {
  isHandled: isSingleCustodianDealSplitFieldMetadata,
  validateValue: (value, field) => field.availableCustodians.some(c => c.value === value.value),
};
